import { UserShort } from "tm-shared/types";

export const filterMembers = (
    members: UserShort[],
    searchQuery: string,
): UserShort[] => {
    const normalizedSearch = searchQuery.trim().toLowerCase();

    if (!normalizedSearch) {
        return members;
    }

    return members.filter(
        (member) =>
            member.fullName.toLowerCase().includes(normalizedSearch) ||
            member.phone.includes(normalizedSearch),
    );
};

export const sortMembersByWorkStatus = (members: UserShort[]): UserShort[] => {
    return [...members].sort((a, b) => {
        if (a.isWorking && !b.isWorking) return -1;
        if (!a.isWorking && b.isWorking) return 1;
        return 0;
    });
};
